import Main from "../Components/Main";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import PageNotFound from "../Pages/PageNotFound";

import ProductList from "../Pages/products/ProductList";
import AddProduct from "../Pages/products/AddProduct";
import ExpenseList from "../Pages/expenses/ExpenseList";
import AddExpense from "../Pages/expenses/AddExpense";
import ExpenseCategory from "../Pages/expenses/ExpenseCategory";
import Calender from "../Components/Calender";
import AddUser from "../Pages/users/AddUser";
import UserList from "../Pages/users/UserList";
import AccountsList from "../Pages/accounts/AccountsList";
import AddAccount from "../Pages/accounts/AddAccount";
import ShopKeeperList from "../Pages/shopKeeper/ShopKeeperList";
import AddShopKeeper from "../Pages/shopKeeper/AddShopKeeper";
import Profile from "../Pages/users/Profile";
import ShopList from "../Pages/shop/ShopList";
import AddShop from "../Pages/shop/AddShop";
import ShopKeeperDetails from "../Pages/shopKeeper/ShopKeeperDetails";
import ShopDetails from "../Pages/shop/ShopDetails";
import AuditLogs from "../Pages/Audit/AudtLogs-list";
import AddFloor from "../Pages/floor/AddFloor";
import FloorList from "../Pages/floor/FloorList";
import FloorDetails from "../Pages/floor/FloorDetails";
import BuildingList from "../Pages/buildings/BuildingList";
import AddBuilding from "../Pages/buildings/AddBuilding";
import BuildingDetails from "../Pages/buildings/BuildingDetails";
import ShopkeeperFullDetails from "../Pages/shopKeeper/ShopkeeperFullDetails";
import AddRent from "../Pages/rents/AddRent";
import FloorDetailsList from "../Pages/floor/FloorDetailsList";
import SoldShopsList from "../Pages/shop/SoldShopsList";
import RentList from "../Pages/rents/RentList";
import Shopkeepers from "../Pages/shop/Shopkeepers";
import GenralJournel from "../Pages/accounts/reports/GenralJournel";
import JournelLedger from "../Pages/accounts/reports/JournelLedger";
import BalanceSheet from "../Pages/accounts/reports/BalanceSheet";
import IncomeStatement from "../Pages/accounts/reports/IncomeStatement";
import TrialBalance from "../Pages/accounts/reports/TrialBalance";
import TransactionLines from "../Pages/accounts/TransactionLines";
import CurrencyRates from "../Pages/accounts/CurrencyRates";
import AddBranch from "../Pages/Branches/AddBranch";
import BranchesList from "../Pages/Branches/BranchesList";
import JournelEntry from "../Pages/accounts/JournelEntry";
import AccountQuickReport from "../Pages/accounts/reports/AccountQuickReport";
import AddContract from "../Pages/shop/AddContract";
import ContractList from "../Pages/shop/ContractList";

function Application() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route element={<ProductList />} path="/productlist" />
        <Route element={<AddProduct />} path="/addproduct" />
        <Route element={<AuditLogs />} path="/admin/audit-logs" />
        {/* Branches */}
        <Route element={<AddBranch />} path="/createBranch" />
        <Route element={<BranchesList />} path="/branches" />

        {/* Accounts */}
        <Route element={<AccountsList />} path="/accounts-list" />
        <Route element={<AddAccount />} path="/add-account" />
        <Route element={<JournelEntry />} path="/journel-entry" />
        <Route element={<CurrencyRates />} path="/currency-rates" />
        {/* Financial Reports */}
        <Route
          element={<AccountQuickReport />}
          path="/account-quick-report/:accountId"
        />
        <Route element={<GenralJournel />} path="/genral-journel" />
        <Route element={<JournelLedger />} path="/journel-ledger" />
        <Route element={<BalanceSheet />} path="/balance-sheet" />
        <Route element={<IncomeStatement />} path="/income-statement" />
        <Route element={<TrialBalance />} path="/trial-balance" />
        <Route
          element={<TransactionLines />}
          path="/genral-journel/transaction-lines/:journalId"
        />

        {/* Expences */}
        <Route element={<ExpenseList />} path="/expense-list" />
        <Route element={<AddExpense />} path="/add-expense" />
        <Route element={<ExpenseCategory />} path="/expense-category" />

        {/* Rents */}
        <Route element={<ExpenseList />} path="/expense-list" />
        <Route element={<AddRent />} path="/add-rent" />
        <Route element={<RentList />} path="/rent-list" />
        <Route element={<ExpenseCategory />} path="/expense-category" />

        {/* Floor */}
        <Route element={<FloorList />} path="floor-list" />
        <Route element={<FloorDetailsList />} path="floors-detailed-list" />
        <Route element={<AddFloor />} path="add-floor" />
        <Route element={<AddFloor edit={true} />} path="edit-floor/:id" />
        <Route element={<FloorDetails />} path="/floor-details/:id" />

        {/* Buildings */}
        <Route element={<BuildingList />} path="/buildings-list" />
        <Route element={<AddBuilding />} path="/add-building" />
        <Route element={<AddBuilding edit={true} />} path="edit-building/:id" />
        <Route element={<BuildingDetails />} path="/building-details/:id" />

        {/* Users */}
        <Route element={<AddUser />} path="add-user" />
        <Route element={<AddUser edit={true} />} path="edit-user/:id" />
        <Route element={<UserList />} path="user-list" />
        <Route element={<Profile />} path="user-profile" />

        {/* Shop Keeper */}
        <Route element={<ShopKeeperList />} path="shopkeeper-list" />
        <Route element={<AddShopKeeper />} path="add-shopkeeper" />
        <Route
          element={<AddShopKeeper edit={true} />}
          path="edit-shopkeeper/:id"
        />
        <Route element={<ShopKeeperDetails />} path="/shopkeeper-details/:id" />
        <Route
          element={<ShopkeeperFullDetails />}
          path="/shopkeeper/:shopkeeperId/full-details"
        />

        {/* Shop */}
        <Route element={<ShopList />} path="shop-list" />
        <Route element={<Shopkeepers />} path="shop-shopkeepers" />
        <Route element={<SoldShopsList />} path="sold-shops-list" />
        <Route path="/add-shop" element={<AddShop />} />
        <Route path="/add-contract" element={<AddContract />} />
        <Route path="/contract-list" element={<ContractList />} />
        <Route path="edit-shop/:id" element={<AddShop edit={true} />} />
        <Route element={<ShopDetails />} path="/shop-details/:id" />

        <Route element={<Calender />} path="calender" />
        <Route element={<PageNotFound />} path="*" />
      </Routes>
    </Router>
  );
}
export default Application;
